import React from 'react';
import styles from './Image.styl';

class Image extends React.Component
{
	render() {
		const className = `${this.props.className ? this.props.className : styles.img} ${this.props.url ? '' : (this.props.noPhotoSmall ? styles.imgNoPhoto110 : styles.imgNoPhoto)}`;
		const style = this.props.url ? {backgroundImage: `url(${this.props.url})`} : null;

		return (
			<div className={className} style={style}></div>
		);
	}
}

export default Image;



// WEBPACK FOOTER //
// ./src/react/ui/Image.jsx